import { render } from "./UploadEnquiry.vue?vue&type=template&id=799e9fd2"
import script from "./UploadEnquiry.vue?vue&type=script&lang=js"
export * from "./UploadEnquiry.vue?vue&type=script&lang=js"

import "./UploadEnquiry.vue?vue&type=style&index=0&id=799e9fd2&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__